var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaxCoursorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.704,
    height: 19.955,
    viewBox: "0 0 12.704 19.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27498",
    "data-name": "Path 27498",
    d: "M43.518,19.978l-2.676-7.212L38.3,14.081a1.042,1.042,0,0,1-1.134-.091,1.133,1.133,0,0,1-.5-1.089l1.5-11.747A1.224,1.224,0,0,1,38.98.112a1.134,1.134,0,0,1,1.27.272L49,8.1a1.134,1.134,0,0,1,.317,1.134,1.089,1.089,0,0,1-.816.816l-2.721.771,2.676,7.212ZM41.84,10.226l2.721,7.393,1.587-.635L43.38,9.591l3.492-.952L39.842,2.38l-1.225,9.48Z",
    transform: "translate(-36.659 -0.023)",
    fill: "#e62e2e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxCoursorIcon);
export default __webpack_public_path__ + "static/media/MaxCoursorIcon.440ba15c204334a2d686bbc14faa8d4d.svg";
export { ForwardRef as ReactComponent };